<template>
  <naj-box
    :title="local.complaints.complaintDetails.selectSession"
    header-icon="mdi-format-list-bulleted-square"
    header-class="sub-header"
    disable-collapsing
    has-footer
  >
    <naj-item-table
      :data-items="formModel.sessionList || []"
      :headers="headers"
      :loading="loading"
      :enable-expand="false"
      :hide-default-no-data="true"
    >
      <template
        slot="selectAction"
        slot-scope="{item, index }"
      >
        <div class="info-item-details-title info-item-checkbox">
          <naj-input
            :key="'selectBoxItem'"
            :type-id="formFieldType.radioButton"
            :value.sync="formModel.selectedSessionId"
            :items="[{...item}]"
            item-value="sessionNo"
            :disabled="formModel.viewMode"
            @change="onSelectionChange(item,index)"
          ></naj-input>
        </div>
        <div class="info-item-details-value" />
      </template>
      <template slot="noData">
        <v-col class="text-center">
          <naj-archive-icon></naj-archive-icon>

          <p class="no-data-text">
            {{ local.complaints.complaintDetails.noDataForSessions }}
          </p>
        </v-col>
      </template>
    </naj-item-table>
  </naj-box>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapComplaintsActions } = createNamespacedHelpers('ComplaintsModule');
export default {
  name: 'SessionsList',
  components: {},
  props: {
    formModel: {
      type: Object,
      required: true,
      default: () => ({ selectedSession: null }),
    },
  },
  data() {
    return {
      loading: false,
      headers: [
        {
          value: 'selectAction',
          text: null,
          isCustomTemplate: true,
        },
        {
          value: 'sessionNo',
          text: this.local.complaints.complaintDetails.sessionHeaders.sessionNo,
        },
        {
          value: 'sessionType',
          text: this.local.complaints.complaintDetails.sessionHeaders.sessionType,
        },
        {
          value: 'sessionDateHijri',
          text: this.local.complaints.complaintDetails.sessionHeaders.sessionDate,
        },
        {
          value: 'sessionStatus',
          text: this.local.complaints.complaintDetails.sessionHeaders.sessionStatus,
        },
        {
          value: 'subCircleName',
          text: this.local.complaints.complaintDetails.sessionHeaders.subCircleName,
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {
  },
  beforeMount() {
    if (this.formModel && this.formModel.sessionList && this.formModel.sessionList.length > 0)
      this.formModel.sessionList.forEach((element) => {
        if ('__value' in element)
          delete element.__value;
        if ('response' in element)
          delete element.response;
      });
  },
  mounted() {
    this.getCaseDetails();
  },
  methods: {
    ...mapComplaintsActions(['getICmsAllCasesDetails']),
    getCaseDetails() {
      if ((!this.formModel.sessionList || this.formModel.sessionList.length == 0) && this.formModel.selectedCase) {
        this.loading = true;
        this.getICmsAllCasesDetails({
          caseNumber: this.formModel.selectedCase.caseNumber,
          courtId: this.formModel.selectedCase.courtId,
          year: this.formModel.selectedCase.year,
          roleInCase: this.formModel.selectedCase.roleInCase,
        })
          .then((data) => {

            if (data.data && data.data.sessionsDetails && data.data.sessionsDetails.sessionsList) {
              this.formModel.sessionList = data.data.sessionsDetails.sessionsList;
            }
          })
          .finally(() => { this.loading = false; });
      }

    },
    onSelectionChange(item) {
      if (this.formModel.selectedSessionId) {
        this.formModel.selectedSession = item;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .info-item-details:has(.info-item-checkbox) {
    flex-grow: 0;
    max-width: 65px;
  }
}
</style>
